export default __webpack_public_path__ + "static/media/our vision image 1.fd3a6fb4.jpg";